import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import zensioLogo from "@/assets/zensio-logo.webp";

interface ZensioLogoProps {
  className?: string;
  size?: number;
  animate?: boolean;
}

export default function ZensioLogo({ className, size = 40, animate = true }: ZensioLogoProps) {
  const img = (
    <img
      src={zensioLogo}
      alt="Zensio"
      width={size}
      height={size}
      decoding="async"
      fetchPriority="high"
      className={cn("shrink-0", className)}
    />
  );

  if (!animate) return img;

  return (
    <motion.div
      className="inline-flex"
      whileHover={{ scale: 1.06, transition: { duration: 0.3, ease: "easeOut" } }}
      whileTap={{ scale: 0.96 }}
    >
      {img}
    </motion.div>
  );
}
